import React, { useState, useEffect } from "react";
import { Modal } from "antd";
import { Container, Button, Box } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import ReactQuill from "react-quill";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-quill/dist/quill.snow.css";
import moment from "moment";

const EditReactQuillModel = ({
  modelTitle,
  content,
  okText,
  cancelText,
  title,
  formFields,
  formFieldsDates,
  onSubmit,
  buttonName,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  useEffect(() => {
    if (formFieldsDates) {
      setStartDate(
        formFieldsDates.find((f) => f.name === "startDate")?.value || null
      );
      setEndDate(
        formFieldsDates.find((f) => f.name === "endDate")?.value || null
      );
    }
  }, [formFieldsDates]);

  const showModal = () => {
    setIsModalOpen(true);
    const initialData = formFields.reduce(
      (acc, field) => ({ ...acc, [field.name]: field.value }),
      {}
    );
    setFormData(initialData);
  };

  const handleQuillChange = (name, value) =>
    setFormData((prev) => ({ ...prev, [name]: value }));

  const handleStartDateChange = (date) => setStartDate(date);
  const handleEndDateChange = (date) => setEndDate(date);

  const { confirm } = Modal;
  const handleSubmit = (e) => {
    const eventStartDate = moment(startDate).format("MM/DD/YYYY");
    const eventEndDate = moment(endDate).format("MM/DD/YYYY");
    e.preventDefault();
    confirm({
      title: modelTitle,
      content: content,
      okText: okText,
      cancelText: cancelText,
      onOk: async () => {
        onSubmit({ ...formData, eventStartDate, eventEndDate });
        setIsModalOpen(false);
      },
    });
  };

  return (
    <>
      <IconButton onClick={showModal}>
        <EditIcon sx={{ color: "#1976d2" }} />
      </IconButton>
      <Modal
        title={title}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
      >
        <Container
          component="form"
          onSubmit={handleSubmit}
          className="form_style border-style"
        >
          {formFields.map(({ name, label, placeholder }, index) => (
            <Box key={index} sx={{mb:3}}>
              <h4>{label}</h4>
              <ReactQuill
                value={formData[name] || ""}
                onChange={(value) => handleQuillChange(name, value)}
                placeholder={placeholder}
              />
            </Box>
          ))}

          <Box className="Date">
            <Box sx={{ mt: 3 }}>
              <h4>Start Date</h4>
              <DatePicker
                showIcon
                toggleCalendarOnIconClick
                isClearable
                placeholderText="Start Date"
                selected={startDate}
                onChange={handleStartDateChange}
                minDate={new Date()}
                maxDate={endDate}
                required
                value={startDate}
              />
            </Box>
            <Box sx={{ mt: 3, mb: 3 }}>
              <h4>End Date</h4>
              <DatePicker
                required
                showIcon
                toggleCalendarOnIconClick
                isClearable
                placeholderText="End Date"
                selected={endDate}
                onChange={handleEndDateChange}
                minDate={(new Date() && startDate) || new Date()}
                value={endDate}
                maxDate={endDate}
              />
            </Box>
          </Box>

          <Button variant="contained" type="submit">
            {buttonName}
          </Button>
        </Container>
      </Modal>
    </>
  );
};

export default EditReactQuillModel;
